/*=========================================================================================
  File Name: moduleTraineeParticipationActions.js
  Description: TraineeParticipation Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default { 
  SaveTraineeParticipation(context, data) {
    debugger
    return new Promise((resolve, reject) => {
      axios.post("api/Trainee/SaveTraineeParticipation", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetModuleByCourseID(context, data) {
    debugger
    return new Promise((resolve, reject) => {
      axios.get("api/Course/GetCourseModulesByCourseID?courseID="+ data.CourseID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetTraineeParticipationByCourseClassID(context, data) {
    debugger
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetTraineeParticipationByCourseClassID?courseClassID="+ data.courseClassID+"&moduleID="+data.moduleID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

}
